<template>
  <v-btn
    class="btn"
    :width="width ? width : 'max-content'"
    :height="height ? height : '38px'"
    color="transparent"
    :disabled="disabled"
    :loading="loading"
    @click="$emit('click')"
  >
    <slot />
  </v-btn>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: null,
    },
    height: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.btn {
  border-radius: 6px;
  font-size: 16px;
  font-weight: 400;
  text-transform: none;
  padding: 8px 10px;
  color: #020817 !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 600 !important;
  line-height: normal;
  border: 1px solid #e2e8f0!important;
  background: transparent !important;
}
</style>